import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from './useLocalStorage';
import { useEstadoApp } from '../context/EstadoAppContext';
import { AuthContext } from '../context/authContext.jsx';
import { initiateSocketConnection } from '../service/socketio.js';

// Abre una obra en modo edición siguiendo el patrón de TablaObras /
// AlertasMejoramientos: setea localStorage (idPartidoObra / isEditingPagos),
// cambia el estado de la app y navega a /inicio.
//
// `isEditingPagos` queda en 'true' (solo lectura) si OTRO usuario la está
// editando; si no, 'false' (edición normal).
export const useAbrirObra = (origen) => {
    const { setItem } = useLocalStorage();
    const { cambiarEstadoApp } = useEstadoApp();
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [arrayEditando, setArrayEditando] = useState([]);

    useEffect(() => {
        let activo = true;
        fetch('/api/arrayEditando')
            .then((r) => r.json())
            .then((data) => { if (activo) setArrayEditando(Array.isArray(data) ? data : []); })
            .catch(() => {});
        const s = initiateSocketConnection();
        const onArrayEditando = (data) => setArrayEditando(Array.isArray(data) ? data : []);
        s.on('array_editando', onArrayEditando);
        return () => {
            activo = false;
            s.off('array_editando', onArrayEditando);
        };
    }, []);

    const isEditingByOtherUser = (obraId) => {
        const safe = Array.isArray(arrayEditando) ? arrayEditando : [];
        return safe.some((objeto) => {
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) return false;
            const userEditClean = String(objeto.user_edit).replace(/"/g, '');
            return objeto.id_edit === obraId && objeto.status === 'editando' && userEditClean !== user;
        });
    };

    const abrirObra = useCallback((codigo) => {
        if (!codigo) return;
        setItem('idPartidoObra', codigo);
        setItem('isEditingPagos', isEditingByOtherUser(codigo) ? 'true' : 'false');
        cambiarEstadoApp('edit_desde_pagos', { obra: codigo, origen });
        navigate(`/inicio?id_partido_obra=${encodeURIComponent(codigo)}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayEditando, user, cambiarEstadoApp, navigate, setItem, origen]);

    return { abrirObra };
};
